import { FC } from 'react';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';
import { useGlobal } from '@/utils/useGlobal';

const FirstKv: FC = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanSmartMeterBackupSwitch');

    return (
        <div className={styles['first-kv']}>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1750831338910/KV_pc.jpg'}
                srcPad={'https://websiteoss.ecoflow.com/upload/image/1751422993878/Major_h5.jpeg'}
                alt={t('first_kv_title')}
                className="banner"
            />
            <div className="content">
                <div className="text-container">
                    <h1>{t(`first_kv_title`)}</h1>
                    <h3>{t(`first_kv_sub_title`)}</h3>
                </div>
            </div>
        </div>
    );
};

export default FirstKv;
